import React from 'react';
import styled from 'styled-components';
import InputRadioType from './InputRadioType';
import { Form } from 'antd';
import { DISCOUNT_VALUE_TYPE } from 'features/cashier/components/Discount/AmountDiscount';
import { PlusOutlined } from '@ant-design/icons';
import PercentDecimalInputPrecision from 'components/PercentDecimalInputPrecision';
import CurrencyInputPrecision from 'components/CurrencyInputPrecision';
import AmountInput from './AmountInput';

const InputRangeIncentive = () => {
  const form = Form.useFormInstance();

  const add = () => {
    form.setFieldsValue({
      rangeIncentives: [
        ...form.getFieldValue('rangeIncentives'),
        { amount: [0, 0], discountValue: 0 },
      ],
    });
  };

  return (
    <Container>
      <BoxJustify>
        <Form.Item name='discountTypeIncentive' initialValue={DISCOUNT_VALUE_TYPE.PERCENT}>
          <InputRadioType />
        </Form.Item>
        <AddButton onClick={() => add()} type='button'>
          <PlusOutlined />
          Add
        </AddButton>
      </BoxJustify>

      <Form.List name='rangeIncentives' initialValue={[{ min: 0, max: 0, discountValue: 0 }]}>
        {(fields, { remove }) => (
          <>
            {fields.map(({ key, name, ...restField }) => (
              <RecordItem key={key}>
                <Form.Item name={[name, 'amount']}>
                  <AmountInput />
                </Form.Item>

                <Form.Item shouldUpdate noStyle>
                  {({ getFieldValue }) => {
                    const discountType = getFieldValue('discountTypeIncentive');
                    return (
                      <LabelBox className='right'>
                        <div className='label'>Discount</div>
                        <Form.Item noStyle {...restField} name={[name, 'discountValue']}>
                          {discountType === DISCOUNT_VALUE_TYPE.PERCENT ? (
                            <PercentDecimalInputPrecision maxValue={100} height={'3.5rem'} />
                          ) : (
                            <CurrencyInputPrecision height={'3.5rem'} textAlign='left' />
                          )}
                        </Form.Item>
                      </LabelBox>
                    );
                  }}
                </Form.Item>
                <div onClick={() => remove(name)} className='close'>
                  <CloseIcon />
                </div>
              </RecordItem>
            ))}

            {/* <Form.Item>
              <Button type='dashed' onClick={() => add()} block icon={<PlusOutlined />}>
                Add Range
              </Button>
            </Form.Item> */}
          </>
        )}
      </Form.List>
    </Container>
  );
};

export default InputRangeIncentive;

const Container = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  gap: 16px;
  align-self: stretch;
`;

const BoxJustify = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const AddButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  background: #6fabb6;
  box-shadow: 0 2px 4px 0 rgba(44, 35, 66, 0.4), 0 4px 8px -3px rgba(45, 35, 66, 0.3),
    0 -2px 0 0 #144b55 inset;
  height: 32px;
  padding: 8px 16px;
  color: #fff;
  text-align: center;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  &:hover {
    opacity: 0.8;
  }
`;

const RecordItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  .right {
    width: 30%;
  }
    .close {
      height: 56px;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      align-items: end;
      justify-content: end;
    }
`;

const LabelBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const CloseIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' fill='none'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M26.9098 5.08971C27.5124 5.69225 27.5124 6.66916 26.9098 7.2717L7.27196 26.9096C6.66942 27.5121 5.69251 27.5121 5.08997 26.9096C4.48743 26.307 4.48743 25.3301 5.08997 24.7276L24.7279 5.08971C25.3304 4.48717 26.3073 4.48717 26.9098 5.08971Z'
      fill='#D2464F'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.09028 5.08971C5.69282 4.48717 6.66973 4.48717 7.27227 5.08971L26.9101 24.7276C27.5127 25.3301 27.5127 26.307 26.9101 26.9096C26.3076 27.5121 25.3307 27.5121 24.7282 26.9096L5.09028 7.2717C4.48774 6.66916 4.48774 5.69225 5.09028 5.08971Z'
      fill='#D2464F'
    />
  </svg>
);
